module.exports = __webpack_public_path__ + "img/logo-component-1.d0d2a5f1.png";